module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('text-overlay', {
    attrs: {
      "show": _vm.querying_api,
      "text": _vm.overlay_text,
      "no-wrap": "",
      "fixed": ""
    }
  }), _vm._v(" "), _c('div', [(_vm.dropDetails.needs_ont_install) ? _c('div', [_c('br'), _vm._v(" "), _c('div', [_c('div', [_vm._m(0), _vm._v(" "), _c('google-maps-draggable', {
    attrs: {
      "draggable": true
    },
    model: {
      value: (_vm.location_details),
      callback: function($$v) {
        _vm.location_details = $$v
      },
      expression: "location_details"
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('xm-input', {
    attrs: {
      "placeholder": _vm.exterior_notes_placeholder,
      "type": "textarea"
    },
    model: {
      value: (_vm.form_data.drop_details.notes),
      callback: function($$v) {
        _vm.$set(_vm.form_data.drop_details, "notes", $$v)
      },
      expression: "form_data.drop_details.notes"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_vm._m(2), _vm._v(" "), _vm._l((_vm.installationOptions), function(installation_option) {
    return _c('div', {
      key: installation_option.installation_type
    }, [_c('div', [_c('label', {
      staticClass: "radio-head"
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "name": "install_type_radio"
      },
      on: {
        "click": function($event) {
          return _vm.setInstallType(installation_option)
        }
      }
    }), _vm._v(" "), _c('span', [_c('b', [_vm._v(_vm._s(installation_option.label))])])]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(installation_option.billing.fees[0].rate) + " (" + _vm._s(installation_option.sub_description) + ")")])]), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(installation_option.description))])]), _vm._v(" "), _c('br')])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('xm-input', {
    attrs: {
      "placeholder": _vm.interior_notes_placeholder,
      "type": "textarea"
    },
    model: {
      value: (_vm.form_data.install_details.notes),
      callback: function($$v) {
        _vm.$set(_vm.form_data.install_details, "notes", $$v)
      },
      expression: "form_data.install_details.notes"
    }
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('Transition', {
    on: {
      "enter": function($event) {
        return _vm.scrolldown('strata-installation-date-details')
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.installTypeChosen && !_vm.querying_api),
      expression: "installTypeChosen && !querying_api"
    }],
    attrs: {
      "id": "strata-installation-date-details"
    }
  }, [_c('div', [_c('h5', [_vm._v("Installation date and time")])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("Pick an install date:")]), _vm._v(" "), _c('b-form-datepicker', {
    attrs: {
      "date-disabled-fn": _vm.dateAvailable,
      "initial-date": _vm.install_start_date,
      "no-highlight-today": ""
    },
    model: {
      value: (_vm.install_date),
      callback: function($$v) {
        _vm.install_date = $$v
      },
      expression: "install_date"
    }
  })], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('Transition', {
    on: {
      "enter": function($event) {
        return _vm.scrolldown('strata-installation-time-details')
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.installDateChosen),
      expression: "installDateChosen"
    }],
    attrs: {
      "id": "strata-installation-time-details"
    }
  }, [_c('label', [_vm._v("Pick an install time:")]), _c('br'), _vm._v(" "), _c('b-dropdown', {
    attrs: {
      "text": _vm.install_time
    }
  }, _vm._l((_vm.install_times), function(installation_item) {
    return _c('b-dropdown-item', {
      key: installation_item.displayTime,
      on: {
        "click": function($event) {
          return _vm.setInstallDate(installation_item)
        }
      }
    }, [_vm._v(" " + _vm._s(installation_item.displayTime + ' (' + installation_item.duration + 'minutes) '))])
  }), 1)], 1)])], 1) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h5', [_vm._v("Fiber installation: home exterior "), _c('small', [_vm._v("(red pin "), _c('span', {
    staticClass: "red-pin-icon"
  }), _vm._v(" shows where the fiber will attach to your home, typically near other utilities). The red pin marks the pre-engineered fiber location where Lehi City plans to reach your home. Note that adjusting this location will trigger an engineering review, potentially leading to extra charges and installation delays.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h5', [_vm._v("Exterior installation notes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h5', [_vm._v("Fiber installation: home interior "), _c('small', [_vm._v("(fiber equipment mounted inside the home on an exterior wall)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h5', [_vm._v("Interior installation notes")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66f165cc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Services/create/StrataResidential.vue
// module id = 1330
// module chunks = 16